import { render, staticRenderFns } from "./dedicated-info.vue?vue&type=template&id=a1274230&scoped=true"
import script from "./dedicated-info.vue?vue&type=script&lang=js"
export * from "./dedicated-info.vue?vue&type=script&lang=js"
import style0 from "./dedicated-info.vue?vue&type=style&index=0&id=a1274230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1274230",
  null
  
)

export default component.exports